<script setup lang="ts">
import {
  useYandexMap,
  createPinLayout,
  getPinIconShape,
  DEFAULT_MAP_ZOOM,
} from '@/shared/lib/yandexMap';
import type { YMaps, LawyerPinType } from '@/shared/lib/yandexMap';

const props = withDefaults(
  defineProps<{ lat: number; lon: number; type?: LawyerPinType }>(),
  { type: 'lawyer' },
);

const isMobile: boolean = useIsMobile();
const mapEl: Ref<HTMLElement | null> = ref(null);

let removePlacemark: (() => void) | null = null;

const init = (ymaps: YMaps, container: HTMLElement) => {
  const map = new ymaps.Map(
    container,
    { center: [props.lat, props.lon], zoom: DEFAULT_MAP_ZOOM, controls: [] },
    { suppressMapOpenBlock: true, yandexMapDisablePoiInteractivity: true },
  );

  const placemark = new ymaps.Placemark(
    [props.lat, props.lon],
    {},
    {
      iconLayout: createPinLayout(ymaps, props.type),
      iconShape: getPinIconShape(),
    },
  );
  map.geoObjects.add(placemark);
  removePlacemark = () => map.geoObjects.remove(placemark);

  return map;
};

onBeforeUnmount(() => {
  removePlacemark?.();
  removePlacemark = null;
});

useYandexMap(mapEl, init);
</script>

<template>
  <div :class="['contact-map', { _mobile: isMobile }]">
    <div ref="mapEl" class="contact-map__container"></div>
  </div>
</template>

<style lang="less">
@import '@/shared/lib/yandexMap/styles/map-point.less';

.contact-map {
  &__container {
    width: 100%;
    height: 220px;
    border-radius: @main-size;
    overflow: hidden;
  }

  &._mobile &__container {
    height: 159px;
  }
}
</style>
